<script>
function x(x,y,z){return [x,y,z].join(' ')}
export let position

</script>


<a-entity position={position}>
    {#each new Array(4).fill(0).map((_,i) => i).reverse() as n, i}
    <a-cone position={x(0,i*0.8,0)} 
            roughness="1" 
            color="#262" 
            radius-bottom={0.2*n+1} 
            radius-top={0.1*n}/>
    {/each}
    <a-cylinder color="#532" 
                height="3" 
                radius="0.3"/>
    
</a-entity>